export const StaticCredentialsTooltip = () => (
  <>
    The owner can generate multiple static secrets that will provide
    corresponding level of access to the files in the pond. The secrets are AWS
    IAM key id and secret for an internally managed IAM users.
  </>
);
